import { GameResultCategory } from '@models/game-result-category.enum';

export const calculatePercentage = (correctScore: number, total: number): number => {
  return total > 0 ? (correctScore / total) * 100 : 0;
};

/**
 * Same bands as fe-ig-predictor:
 * 0–20% → POOR, 20.1–60% → AVERAGE, 60.1–99.99% → GOOD, 100% → EXCELLENT
 */
export const getResultCategory = (percent: number): GameResultCategory => {
  if (percent >= 100) return GameResultCategory.EXCELLENT;
  if (percent > 60) return GameResultCategory.GOOD;
  if (percent > 20) return GameResultCategory.AVERAGE;
  return GameResultCategory.POOR;
};

export const getTitle = (
  correctScore: number,
  total: number,
  isWin: boolean,
  prizeAmount = 0,
): string => {
  const category = getResultCategory(calculatePercentage(correctScore, total));

  switch (category) {
    case GameResultCategory.POOR:
      return 'ouch...';
    case GameResultCategory.AVERAGE:
      return 'not bad!';
    case GameResultCategory.GOOD:
      return 'you were close!';
    case GameResultCategory.EXCELLENT:
      return isWin && prizeAmount > 0
        ? `Congrats you have won €${prizeAmount}!`
        : 'congratulations!';
  }
};

export const getEmoji = (correctScore: number, total: number, _isWin?: boolean): string => {
  const category = getResultCategory(calculatePercentage(correctScore, total));

  switch (category) {
    case GameResultCategory.POOR:
      return '/assets/images/sad-face.gif';
    case GameResultCategory.AVERAGE:
      return '/assets/images/not-bad.gif';
    case GameResultCategory.GOOD:
      return '/assets/images/so-close.gif';
    case GameResultCategory.EXCELLENT:
      return '/assets/images/money-face.gif';
  }
};

export const getMessage = (
  correctScore: number,
  total: number,
  isWin: boolean,
  prizeAmount = 0,
): string => {
  const category = getResultCategory(calculatePercentage(correctScore, total));

  switch (category) {
    case GameResultCategory.POOR:
      return 'That was a rough one. But hey, every champion starts somewhere.';
    case GameResultCategory.AVERAGE:
      return 'Plenty of room to improve. Keep playing and sharpen your picks.';
    case GameResultCategory.GOOD:
      return 'You were just one away from winning the jackpot. Your best round yet. Can you go all the way next time?';
    case GameResultCategory.EXCELLENT:
      return isWin
        ? `You have won €${prizeAmount || 0}! You will soon receive an email on how you will retrieve your winnings from the game.`
        : 'You have won the jackpot! You will soon receive an email on how you will retrieve your winnings from the game.';
  }
};
